module.exports = __webpack_public_path__ + "img/item1-6.a3c5b730.jpg";